import React from "react";
import { Routes, Route } from "react-router-dom";
import { Layout, Tag } from "antd";
import AppHeader from "./components/app-header";
import AppFooter from "./components/app-footer";
import SignIn from "./screens/signin";
import Signup from "./screens/signup";
import Dashboard from "./screens/dashboard";
import Results from "./screens/results";

function App() {
  const { Content } = Layout;

  let reqData = [
    {
      id: 1,
      requestDate: "11/18/2024",
      type: "Hotel",
      location: "Mumbai",
      name: "The Lalit Mumbai",
      dates: "21/01/2025 - 22/01/2025",
      room: "Premier Room Twin Bed",
      price: "₹ 20,636",
      status: "Confirmed",
    },
    {
      id: 2,
      requestDate: "11/24/2024",
      type: "Hotel",
      location: "Mumbai",
      name: "Ginger Mumbai Airport",
      dates: "18/01/2025 - 19/01/2025",
      room: "Premier Room Twin Bed",
      price: "₹ 11,999",
      status: "Confirmed",
    },
    {
      id: 3,
      requestDate: "11/28/2024",
      type: "Hotel",
      location: "Mumbai",
      name: "Lemon Tree Premier",
      dates: "14/01/2025 - 15/01/2025",
      room: "Premier Room Twin Bed",
      price: "₹ 14,999",
      status: "Confirmed",
    },
    {
      id: 4,
      requestDate: "11/30/2024",
      type: "Hotel",
      location: "Mumbai",
      name: "Taj Santacruz, Mumbai",
      dates: "12/01/2025 - 11/01/2025",
      room: "Premier Room Twin Bed",
      price: "₹ 23,500",
      status: "Approved",
    },
    {
      id: 5,
      requestDate: "01/01/2025",
      type: "Hotel",
      location: "Mumbai",
      name: "Trident Bandra Kurla",
      dates: "08/01/2025 - 09/01/2025",
      room: "Premier Room Twin Bed",
      price: "₹ 24,300",
      status: "New",
    },
  ];

  if (!localStorage.getItem("reqData"))
    localStorage.setItem("reqData", JSON.stringify(reqData));

  return (
    <Layout>
      <AppHeader key={window.location.pathname} />
      <Layout>
        <Content>
          <Routes>
            <Route path="*" element={<SignIn />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/results" element={<Results />} />
          </Routes>
        </Content>
      </Layout>
      <AppFooter reqData={reqData} />
    </Layout>
  );
}

export default App;
